import { render, staticRenderFns } from "./IND.vue?vue&type=template&id=1240e9d6&scoped=true&"
import script from "./IND.vue?vue&type=script&lang=js&"
export * from "./IND.vue?vue&type=script&lang=js&"
import style0 from "./IND.vue?vue&type=style&index=0&id=1240e9d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1240e9d6",
  null
  
)

export default component.exports